import React from 'react';
import { FileText, ShieldCheck, Truck, CreditCard, RotateCcw, Scale, AlertTriangle } from 'lucide-react';

const TermsPage = () => {
    return (
        <div className="min-h-screen bg-background">
            <section className="relative py-24 bg-primary text-white">
                <div className="container-main">
                    <h1 className="font-serif text-4xl md:text-5xl font-bold">Общи условия</h1>
                    <p className="mt-4 text-white/80">Последна актуализация: Април 2026 г.</p>
                </div>
            </section>

            <section className="section-spacing bg-white">
                <div className="container-main">
                    <div className="max-w-4xl mx-auto">
                        
                        {/* Company Info Box */}
                        <div className="bg-amber-50 border border-amber-200 rounded-xl p-6 mb-8">
                            <h2 className="font-serif text-xl font-bold text-amber-900 mb-3 flex items-center gap-2">
                                <FileText className="w-5 h-5" />
                                Данни за търговеца
                            </h2>
                            <div className="grid md:grid-cols-2 gap-4 text-sm text-amber-800">
                                <div>
                                    <p><strong>Фирма:</strong> ВКУСЪТ НА ТУРЦИЯ ЕООД (VKUSAT NA TURKEY EOOD)</p>
                                    <p><strong>ЕИК:</strong> 208822640</p>
                                    <p><strong>ДДС №:</strong> BG208822640</p>
                                    <p><strong>МОЛ:</strong> Димитър Александров Веселинов</p>
                                </div>
                                <div>
                                    <p><strong>Адрес на управление:</strong> гр. София, ул. Осогово 60</p>
                                    <p><strong>Телефон:</strong> 0899 97 27 27</p>
                                    <p><strong>Имейл:</strong> vkustnaturciq39@gmail.com</p>
                                </div>
                            </div>
                        </div>

                        <div className="prose prose-lg max-w-none">
                            
                            {/* 1. General */}
                            <div className="mb-8">
                                <h2 className="font-serif text-2xl font-bold flex items-center gap-2">
                                    <Scale className="w-6 h-6 text-amber-600" />
                                    1. Общи положения
                                </h2>
                                <p className="text-muted-foreground">
                                    Настоящите общи условия уреждат взаимоотношенията между ВКУСЪТ НА ТУРЦИЯ ЕООД (VKUSAT NA TURKEY EOOD), ЕИК 208822640 
                                    (наричан по-нататък „Продавач" или „Ние") и всички лица, които използват онлайн магазина 
                                    vkusutnaturcia.bg (наричани по-нататък „Клиент" или „Вие").
                                </p>
                                <p className="text-muted-foreground">
                                    С извършването на поръчка Клиентът декларира, че е запознат с настоящите Общи условия 
                                    и се съгласява с тях.
                                </p>
                            </div>

                            {/* 2. Orders */}
                            <div className="mb-8">
                                <h2 className="font-serif text-2xl font-bold flex items-center gap-2">
                                    <CreditCard className="w-6 h-6 text-amber-600" />
                                    2. Поръчки и плащане
                                </h2>
                                <p className="text-muted-foreground">
                                    Клиентът може да направи поръчка чрез онлайн магазина 24 часа в денонощието, 7 дни в седмицата. 
                                    Поръчката се счита за приета след потвърждение от страна на Продавача по имейл или телефон.
                                </p>
                                <p className="text-muted-foreground">
                                    <strong>Минимална стойност на поръчка:</strong> 15.00 EUR
                                </p>
                                <p className="text-muted-foreground">
                                    <strong>Цени:</strong> Всички цени са в евро (EUR) и включват ДДС 20%. 
                                    Продавачът си запазва правото да променя цените без предварително уведомление. 
                                    Промените не засягат вече направени и потвърдени поръчки.
                                </p>
                                <p className="text-muted-foreground">
                                    <strong>Начини на плащане:</strong>
                                </p>
                                <ul className="text-muted-foreground list-disc pl-6">
                                    <li>Наложен платеж (плащане при доставка)</li>
                                    <li>Банкова карта (Visa, Mastercard, American Express) чрез защитена Stripe платформа</li>
                                    <li>Банков превод</li>
                                </ul>
                            </div>

                            {/* 3. Delivery */}
                            <div className="mb-8">
                                <h2 className="font-serif text-2xl font-bold flex items-center gap-2">
                                    <Truck className="w-6 h-6 text-amber-600" />
                                    3. Доставка
                                </h2>
                                <p className="text-muted-foreground">
                                    Доставката се извършва чрез куриерска фирма <strong>Еконт Експрес</strong> до адрес или до офис на Еконт 
                                    в цяла България.
                                </p>
                                <p className="text-muted-foreground">
                                    <strong>Срок на доставка:</strong> 1-2 работни дни за градовете, 2-3 работни дни за по-малките населени места.
                                </p>
                                <p className="text-muted-foreground">
                                    <strong>Цена на доставката:</strong> Изчислява се автоматично според теглото на поръчката, 
                                    избрания начин на доставка (до адрес или до офис) и местоназначението.
                                </p>
                                <p className="text-muted-foreground">
                                    Продавачът не носи отговорност за забавяния, причинени от куриерската компания или 
                                    форсмажорни обстоятелства.
                                </p>
                            </div>

                            {/* 4. Right of Withdrawal - 14 days */}
                            <div className="mb-8 p-6 bg-green-50 border border-green-200 rounded-xl">
                                <h2 className="font-serif text-2xl font-bold flex items-center gap-2 text-green-800">
                                    <RotateCcw className="w-6 h-6" />
                                    4. Право на отказ (14 дни)
                                </h2>
                                <p className="text-green-700 font-medium">
                                    Съгласно Закона за защита на потребителите (ЗЗП), имате право да се откажете от договора 
                                    в срок от <strong>14 календарни дни</strong>, без да посочвате причина и без да дължите 
                                    обезщетение или неустойка.
                                </p>
                                <p className="text-green-700 mt-3">
                                    <strong>Срокът започва да тече от:</strong> датата на получаване на стоката от Вас или от 
                                    трето лице, посочено от Вас.
                                </p>
                                <p className="text-green-700 mt-3">
                                    <strong>Как да упражните правото си:</strong>
                                </p>
                                <ol className="text-green-700 list-decimal pl-6 mt-2">
                                    <li>Уведомете ни писмено на имейл: vkustnaturciq39@gmail.com или по телефона: 0899 97 27 27</li>
                                    <li>Посочете име, адрес, номер на поръчка и продукти за връщане</li>
                                    <li>Върнете стоката в оригинална опаковка, неизползвана, с всички етикети</li>
                                    <li>Разходите за връщане са за сметка на Клиента</li>
                                </ol>
                                <p className="text-green-700 mt-3">
                                    <strong>Възстановяване на сумата:</strong> В срок до 14 дни от получаване на върнатата стока, 
                                    ще възстановим платената сума по същия начин на плащане.
                                </p>
                                <div className="mt-4 p-3 bg-amber-100 rounded-lg">
                                    <p className="text-amber-800 text-sm flex items-start gap-2">
                                        <AlertTriangle className="w-5 h-5 flex-shrink-0 mt-0.5" />
                                        <span>
                                            <strong>Изключения:</strong> Правото на отказ не се прилага за хранителни продукти, 
                                            които са с кратък срок на годност или могат да се развалят бързо, както и за стоки, 
                                            чиято опаковка е била отворена след доставката.
                                        </span>
                                    </p>
                                </div>
                            </div>

                            {/* 5. Complaints */}
                            <div className="mb-8">
                                <h2 className="font-serif text-2xl font-bold">5. Рекламации</h2>
                                <p className="text-muted-foreground">
                                    При получаване на повредена или несъответстваща стока, Клиентът има право да подаде рекламация 
                                    в срок от <strong>14 дни</strong> от получаването.
                                </p>
                                <p className="text-muted-foreground">
                                    Рекламацията се подава писмено на имейл vkustnaturciq39@gmail.com, като се посочва:
                                </p>
                                <ul className="text-muted-foreground list-disc pl-6">
                                    <li>Номер на поръчка</li>
                                    <li>Описание на проблема</li>
                                    <li>Снимки на продукта (ако е приложимо)</li>
                                </ul>
                                <p className="text-muted-foreground">
                                    Продавачът се задължава да отговори на рекламацията в срок от 14 дни.
                                </p>
                            </div>

                            {/* 6. Data Protection */}
                            <div className="mb-8">
                                <h2 className="font-serif text-2xl font-bold flex items-center gap-2">
                                    <ShieldCheck className="w-6 h-6 text-amber-600" />
                                    6. Защита на личните данни
                                </h2>
                                <p className="text-muted-foreground">
                                    Продавачът се задължава да защитава личните данни на Клиентите в съответствие с 
                                    Общия регламент за защита на данните (GDPR) и Закона за защита на личните данни.
                                </p>
                                <p className="text-muted-foreground">
                                    Подробна информация за обработката на лични данни можете да намерите в нашата{' '}
                                    <a href="/privacy" className="text-amber-600 hover:underline">Политика за поверителност</a>.
                                </p>
                            </div>

                            {/* 7. Disputes */}
                            <div className="mb-8">
                                <h2 className="font-serif text-2xl font-bold">7. Спорове</h2>
                                <p className="text-muted-foreground">
                                    При възникване на спор между Продавача и Клиента, страните се задължават да положат усилия 
                                    за доброволното му уреждане.
                                </p>
                                <p className="text-muted-foreground">
                                    Клиентът може да подаде жалба до Комисията за защита на потребителите (КЗП) или да използва 
                                    платформата за онлайн решаване на спорове на ЕС:{' '}
                                    <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" 
                                       className="text-amber-600 hover:underline">
                                        ec.europa.eu/consumers/odr
                                    </a>
                                </p>
                            </div>

                            {/* 8. Changes */}
                            <div className="mb-8">
                                <h2 className="font-serif text-2xl font-bold">8. Промени в условията</h2>
                                <p className="text-muted-foreground">
                                    Продавачът си запазва правото да променя настоящите общи условия. 
                                    Промените влизат в сила от момента на публикуването им на сайта и не засягат вече направени поръчки.
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TermsPage;
